/** Super admin: public-site visits — pages, sources, devices and approximate place (medopd-docs 91). */
import { fetchApi } from '../client';

export interface SiteVisitTotals { pageViews: number; visitors: number; liveNow: number }
export interface SiteVisitDay { day: string; pageViews: number; visitors: number }
export interface SiteVisitPlace {
  countryCode?: string | null;
  country?: string | null;
  region?: string | null;
  city?: string | null;
  pageViews: number;
  visitors: number;
}
export interface SiteVisitCount { key: string; pageViews: number; visitors: number }
export interface SiteVisitPage { path: string; pageType: string; pageViews: number; visitors: number }
export interface SiteVisitGeo { configured: boolean; database?: string | null; builtOn?: string | null; attribution: string; attributionUrl: string }

export interface SiteVisitReport {
  from: string;
  to: string;
  totals: SiteVisitTotals;
  daily: SiteVisitDay[];
  countries: SiteVisitPlace[];
  regions: SiteVisitPlace[];
  cities: SiteVisitPlace[];
  pages: SiteVisitPage[];
  pageTypes: SiteVisitCount[];
  sources: SiteVisitCount[];
  devices: SiteVisitCount[];
  geo: SiteVisitGeo;
}

export const siteVisitorsModule = {
  /** The last {@code days} days (India dates), today included. */
  report: (days: number) => fetchApi<SiteVisitReport>(`/api/admin/site-visitors?days=${encodeURIComponent(String(days))}`),
};
